/* Shoemageddon hero: SHOEMAGEDDON hyperspace.
   Thousands of tiny sneaker particles + star streaks pour out of a central
   vanishing point on pure black. Every 1-3 s a big sneaker blasts past the
   camera with a neon flash. 12 original silhouettes x 17 colorways, all drawn
   here as SVG (no real brands or logos), pre-rendered into 3 sprite atlases.
   DPR-aware, adaptive quality (cuts particles when frames run > 20 ms),
   pauses when the tab is hidden, clean still frame for prefers-reduced-motion.
   Debug/metrics: window.__warp */
(function(){
"use strict";
var canvas=document.getElementById('space'); if(!canvas||!canvas.getContext) return;
var ctx=canvas.getContext('2d',{alpha:false});
var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---- 12 original sneaker silhouettes x 17 colorways (no brand marks) ----
   viewBox 0 0 320 160, toe pointing right. */
var COLORWAYS=[
 // neon
 {n:'volt-black',  up:'#111118',up2:'#34343f',pan:'#1d1d26',acc:'#b6ff2e',col:'#b6ff2e',lace:'#f4f4f4',mid:'#e8e8ee',sole:'#b6ff2e',tr:'182,255,46'},
 {n:'pink-uv',     up:'#ff2d8a',up2:'#ff86c0',pan:'#7a1fff',acc:'#ffe14d',col:'#14141c',lace:'#ffffff',mid:'#f1ecff',sole:'#7a1fff',tr:'255,45,138'},
 {n:'cyan-cobalt', up:'#1546ff',up2:'#5b85ff',pan:'#0a1a66',acc:'#00f0ff',col:'#ffe14d',lace:'#ffe14d',mid:'#e3eaff',sole:'#00f0ff',tr:'0,240,255'},
 {n:'flare',       up:'#ff6a13',up2:'#ffa060',pan:'#ff2d8a',acc:'#ffe14d',col:'#101014',lace:'#101014',mid:'#fff2e6',sole:'#ff2d8a',tr:'255,106,19'},
 {n:'toxic',       up:'#39ff14',up2:'#a6ff8a',pan:'#0b3d0b',acc:'#ff00e6',col:'#0b3d0b',lace:'#ff00e6',mid:'#f0fff0',sole:'#ff00e6',tr:'57,255,20'},
 // pastel
 {n:'lilac-mint',  up:'#c9b6ff',up2:'#e6dcff',pan:'#9ff5d8',acc:'#7a5cff',col:'#9ff5d8',lace:'#ffffff',mid:'#ffffff',sole:'#9ff5d8',tr:'201,182,255'},
 {n:'peach-sky',   up:'#ffc4a8',up2:'#ffe0d1',pan:'#a8dcff',acc:'#ff7a59',col:'#a8dcff',lace:'#ffffff',mid:'#fffaf5',sole:'#a8dcff',tr:'255,196,168'},
 {n:'bubblegum',   up:'#ffb3d9',up2:'#ffd9ec',pan:'#fff3b0',acc:'#ff4fa3',col:'#fff3b0',lace:'#ffffff',mid:'#ffffff',sole:'#ff9ccc',tr:'255,179,217'},
 // black / white
 {n:'panda',       up:'#f6f6f8',up2:'#ffffff',pan:'#111114',acc:'#111114',col:'#111114',lace:'#ffffff',mid:'#ffffff',sole:'#111114',tr:'255,255,255'},
 {n:'triple-black',up:'#0c0c10',up2:'#2b2b33',pan:'#1a1a20',acc:'#ffffff',col:'#000000',lace:'#0c0c10',mid:'#1a1a20',sole:'#2a2a30',tr:'200,200,215'},
 {n:'white-volt',  up:'#f2f2f5',up2:'#ffffff',pan:'#dcdce4',acc:'#b6ff2e',col:'#b6ff2e',lace:'#111',mid:'#ffffff',sole:'#b6ff2e',tr:'182,255,46'},
 // color-blocked
 {n:'primary',     up:'#e0182d',up2:'#ff5263',pan:'#1546ff',acc:'#ffd400',col:'#ffd400',lace:'#ffffff',mid:'#ffffff',sole:'#1546ff',tr:'255,60,80'},
 {n:'sunset-block',up:'#7a1fff',up2:'#a46bff',pan:'#ff6a13',acc:'#39ff14',col:'#39ff14',lace:'#ffffff',mid:'#ffeedd',sole:'#ff6a13',tr:'164,107,255'},
 {n:'teal-magenta',up:'#00b3a4',up2:'#40e0d0',pan:'#ff00a8',acc:'#ffffff',col:'#ff00a8',lace:'#ffffff',mid:'#f0fffd',sole:'#ff00a8',tr:'0,230,210'},
 // metallic
 {n:'chrome',      up:'#9aa0ad',up2:'#f4f6fb',pan:'#5d636f',acc:'#00f0ff',col:'#2b2f38',lace:'#e9ecf3',mid:'#dfe3ea',sole:'#444a55',tr:'220,230,255',metal:1},
 {n:'gold',        up:'#b8860b',up2:'#ffe27a',pan:'#7a5a05',acc:'#ffffff',col:'#3a2a00',lace:'#fff6cc',mid:'#fff3c4',sole:'#7a5a05',tr:'255,215,90',metal:1},
 {n:'holo',        up:'#ff6bd6',up2:'#6bf3ff',pan:'#b18cff',acc:'#ffffff',col:'#2a1a40',lace:'#ffffff',mid:'#f7f2ff',sole:'#6bf3ff',tr:'190,150,255',metal:1}
];
var SIL={
 hightop:  {hy:10, tx:110,ty:70, b:112,mh:18,os:9},
 runner:   {hy:52, tx:96, ty:88, b:114,mh:14,os:6},
 court:    {hy:46, tx:104,ty:80, b:110,mh:24,os:4},
 skate:    {hy:40, tx:106,ty:80, b:114,mh:18,os:6},
 dad:      {hy:44, tx:100,ty:74, b:96, mh:34,os:8},
 trail:    {hy:44, tx:100,ty:80, b:108,mh:18,os:12},
 slipon:   {hy:58, tx:112,ty:86, b:116,mh:14,os:6},
 slide:    {b:116,mh:16,os:6},
 boot:     {hy:4,  tx:100,ty:72, b:110,mh:14,os:16},
 midtop:   {hy:30, tx:106,ty:78, b:114,mh:16,os:6},
 sock:     {hy:26, tx:112,ty:84, b:112,mh:22,os:6},
 platform: {hy:56, tx:106,ty:86, b:90, mh:42,os:6}
};
var SIL_NAMES=Object.keys(SIL);
function sneakerSVG2(name,c,uid){
  var s=SIL[name],b=s.b,mh=s.mh,os=s.os,o=[],id='g'+uid;
  var grad=c.metal?
    '<linearGradient id="'+id+'" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="'+c.up2+'"/><stop offset=".35" stop-color="'+c.up+'"/><stop offset=".55" stop-color="'+c.up2+'"/><stop offset="1" stop-color="'+c.up+'"/></linearGradient>':
    '<linearGradient id="'+id+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+c.up2+'"/><stop offset="1" stop-color="'+c.up+'"/></linearGradient>';
  var OUT='stroke="rgba(255,255,255,.28)" stroke-width="1.6"';
  // outsole (with lugs for trail/boot)
  var ob=b+mh, oe=ob+os;
  if(name==='trail'||name==='boot'){
    var lug='M16 '+ob+' L300 '+ob+' L300 '+(oe-5);
    for(var x=300;x>20;x-=14) lug+=' L'+(x-7)+' '+oe+' L'+(x-14)+' '+(oe-5);
    o.push('<path d="'+lug+' Z" fill="'+c.sole+'" '+OUT+'/>');
  } else o.push('<path d="M16 '+ob+' L298 '+ob+' Q308 '+ob+' 306 '+oe+' L26 '+oe+' Q16 '+oe+' 16 '+ob+' Z" fill="'+c.sole+'" '+OUT+'/>');
  // midsole
  o.push('<path d="M14 '+b+' L300 '+b+' Q314 '+(b+2)+' 312 '+(b+mh*.6)+' Q310 '+ob+' 296 '+ob+' L28 '+ob+' Q12 '+ob+' 12 '+(b+mh*.5)+' Z" fill="'+c.mid+'"/>');
  if(name==='dad'){ o.push('<path d="M20 '+(b+12)+' q30 -10 60 0 t60 0 t60 0 t60 0 t60 0 L300 '+(b+24)+' L20 '+(b+24)+' Z" fill="'+c.pan+'"/>'); o.push('<path d="M40 '+(b+6)+' h60" stroke="'+c.acc+'" stroke-width="4"/>'); }
  if(name==='platform'){ o.push('<rect x="13" y="'+(b+mh*.45)+'" width="298" height="'+(mh*.22)+'" fill="'+c.pan+'"/>'); o.push('<rect x="13" y="'+(b+mh*.75)+'" width="298" height="4" fill="'+c.acc+'"/>'); }
  if(name==='skate'||name==='court') o.push('<path d="M20 '+(b+mh*.5)+' H300" stroke="'+c.acc+'" stroke-width="3"/>');
  if(name==='runner'||name==='sock') o.push('<path d="M40 '+(b+mh*.55)+' q24 9 48 0 t48 0 t48 0 t48 0" fill="none" stroke="'+c.acc+'" stroke-width="3" stroke-linecap="round"/>');
  if(name==='slide'){
    o.push('<path d="M20 '+(b-4)+' Q160 '+(b-10)+' 300 '+(b-4)+' L300 '+b+' L20 '+b+' Z" fill="'+c.pan+'"/>');
    o.push('<path d="M120 '+(b-2)+' Q118 54 190 52 Q262 54 268 '+(b-2)+' Z" fill="url(#'+id+')" '+OUT+'/>');
    o.push('<path d="M150 74 h80 M156 88 h72" stroke="'+c.acc+'" stroke-width="6" stroke-linecap="round"/>');
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -24 320 184" width="320" height="184"><defs>'+grad+'</defs>'+o.join('')+'</svg>';
  }
  var hy=s.hy,tx=s.tx,ty=s.ty;
  // upper
  var ud='M18 '+b+' L16 '+(hy+8)+' Q16 '+(hy-2)+' 34 '+(hy-2)+' L'+tx+' '+(hy-4)+' Q'+(tx+10)+' '+(hy-4)+' '+(tx+16)+' '+(hy+6)+' L'+(tx+70)+' '+ty+' Q'+(tx+80)+' '+(ty+2)+' 250 '+(ty+4)+' Q300 '+(ty+10)+' 306 '+b+' Z';
  o.push('<path d="'+ud+'" fill="url(#'+id+')" '+OUT+'/>');
  if(name==='sock'){ var kn='';for(var k=0;k<16;k++) kn+='<path d="M'+(4+k*20)+' '+b+' l18 -'+(b-hy+10)+'"/>'; o.push('<clipPath id="k'+uid+'"><path d="'+ud+'"/></clipPath><g clip-path="url(#k'+uid+')" stroke="rgba(255,255,255,.14)" stroke-width="3">'+kn+'</g>'); }
  // toe cap / overlays
  if(name!=='sock') o.push('<path d="M232 '+(ty+3)+' L250 '+(ty+4)+' Q300 '+(ty+10)+' 306 '+b+' L224 '+b+' Q214 '+(ty+18)+' 232 '+(ty+3)+' Z" fill="'+c.pan+'"/>');
  if(name==='court') for(var d=0;d<3;d++) for(var e=0;e<4;e++) o.push('<circle cx="'+(250+e*12)+'" cy="'+(ty+12+d*7)+'" r="1.8" fill="rgba(0,0,0,.35)"/>');
  if(name==='trail') o.push('<path d="M262 '+(b-12)+' Q300 '+(b-12)+' 308 '+b+' L262 '+b+' Z" fill="'+c.acc+'"/>');
  // heel counter + tab
  o.push('<path d="M18 '+b+' L16 '+(hy+8)+' Q16 '+(hy+2)+' 30 '+hy+' L50 '+(hy-1)+' Q42 '+((hy+b)/2)+' 64 '+b+' Z" fill="'+c.pan+'"/>');
  o.push('<rect x="10" y="'+(hy+2)+'" width="12" height="'+Math.min(44,(b-hy)*.55)+'" rx="5" fill="'+c.acc+'"/>');
  // collar opening
  var cm=(34+tx)/2, cd=name==='skate'?16:10;
  o.push('<path d="M34 '+(hy-2)+' L'+tx+' '+(hy-4)+' Q'+(tx-10)+' '+(hy+cd)+' '+cm+' '+(hy+cd+2)+' Q40 '+(hy+cd+2)+' 34 '+(hy-2)+' Z" fill="'+c.col+'"/>');
  if(name==='sock') o.push('<path d="M34 '+(hy-14)+' L'+(tx-4)+' '+(hy-16)+' L'+tx+' '+(hy-4)+' L34 '+(hy-2)+' Z" fill="'+c.col+'"/>');
  // laces / gore / tongue
  if(name==='slipon'){
    o.push('<path d="M'+(tx+12)+' '+(hy+2)+' L'+(tx+40)+' '+(hy+24)+' L'+(tx+66)+' '+(ty-2)+'" fill="none" stroke="'+c.col+'" stroke-width="5"/>');
    for(var q=0;q<8;q++) o.push('<rect x="'+(70+q*20)+'" y="'+(b-10)+'" width="10" height="6" fill="'+(q%2?c.acc:c.pan)+'"/>');
  } else {
    if(name!=='sock') o.push('<path d="M'+(tx-8)+' '+(hy-2)+' Q'+tx+' '+(hy-24)+' '+(tx+20)+' '+(hy-20)+' Q'+(tx+28)+' '+(hy-17)+' '+(tx+22)+' '+(hy-6)+' L'+(tx+14)+' '+(hy+14)+' Z" fill="'+c.up2+'"/>');
    var x0=tx+16,y0=hy+6,x1=tx+66,y1=ty-2,nL=name==='boot'||name==='hightop'?7:5;
    var lg='';for(var L=0;L<nL;L++){var t=L/(nL-1),lx=x0+(x1-x0)*t,ly=y0+(y1-y0)*t;lg+='<path d="M'+(lx-8)+' '+(ly+4)+' l16 -8"/>';}
    o.push('<g stroke="'+c.lace+'" stroke-width="4.5" stroke-linecap="round">'+lg+'</g>');
  }
  // straps
  if(name==='hightop'||name==='midtop') o.push('<path d="M20 '+(hy+22)+' L'+(tx+4)+' '+(hy+18)+' L'+(tx+8)+' '+(hy+34)+' L22 '+(hy+38)+' Z" fill="'+c.acc+'"/>');
  if(name==='boot'){ o.push('<rect x="4" y="'+(hy-6)+'" width="14" height="22" rx="4" fill="'+c.acc+'"/>'); o.push('<path d="M22 '+(b-6)+' H300" stroke="'+c.acc+'" stroke-width="4"/>'); }
  // original side marks (stars / bolts / stripes / orbit), never a real logo
  var mk=(uid*7)%4, my=(Math.max(hy,40)+b)/2+4;
  if(mk===0) o.push('<path d="M86 '+(my-12)+' L140 '+(my-12)+' L124 '+(my-2)+' L178 '+my+' L100 '+(my+16)+' L116 '+(my+5)+' L74 '+(my+5)+' Z" fill="'+c.acc+'"/>');
  else if(mk===1) o.push('<path d="M120 '+(my-16)+' l7 14 l15 2 l-11 10 l3 15 l-14 -7 l-14 7 l3 -15 l-11 -10 l15 -2 Z" fill="'+c.acc+'"/>');
  else if(mk===2) o.push('<path d="M76 '+(my+12)+' L170 '+(my-14)+' M86 '+(my+18)+' L180 '+(my-8)+'" stroke="'+c.acc+'" stroke-width="7" stroke-linecap="round"/>');
  else o.push('<circle cx="128" cy="'+my+'" r="12" fill="none" stroke="'+c.acc+'" stroke-width="5"/><ellipse cx="128" cy="'+my+'" rx="26" ry="6" fill="none" stroke="'+c.acc+'" stroke-width="3" transform="rotate(-18 128 '+my+')"/>');
  o.push('<path d="M24 '+(b-4)+' L298 '+(b-4)+'" stroke="rgba(255,255,255,.3)" stroke-width="1.4" stroke-dasharray="4 4"/>');
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -24 320 184" width="320" height="184"><defs>'+grad+'</defs>'+o.join('')+'</svg>';
}

// ---- tunables -------------------------------------------------------------
var CFG={
  speed:1.0,            // z units / s at full warp (z: 1 far -> 0 at camera)
  streak:0.11,          // streak length, seconds of travel
  starsPerMpx:520,
  shoesDesktop:2600, shoesMobile:850, shoesMin:400,
  shoeBase:3.4,         // particle width in px at z=1 (grows as 1/z)
  blastEvery:[1.0,3.0], // seconds between big fly-bys
  blastBase:170,        // fly-by width at z=1 (it ends ~400px+ wide as it rips past)
  ramp:0.5,
  slowMs:20,            // cut particles when avg frame interval > 20 ms
  recoverDrawMs:8       // add them back when avg draw time < 8 ms
};
var RATIO=184/320, NV=SIL_NAMES.length*COLORWAYS.length;
var SIZES=[24,64,160], ATL=[], atlasCols=COLORWAYS.length;
var vReady=[], vList=[], images=[], blastCache={};

// ---- sprite atlases: one canvas per size, cell = variant -----------------
SIZES.forEach(function(sz,i){
  var c=document.createElement('canvas'); c.width=sz*atlasCols; c.height=Math.ceil(sz*RATIO)*SIL_NAMES.length;
  ATL[i]={c:c,x:c.getContext('2d'),w:sz,h:Math.ceil(sz*RATIO)};
});
function loadVariant(v){
  var si=(v/COLORWAYS.length)|0, ci=v%COLORWAYS.length, img=new Image();
  img.onload=function(){
    for(var i=0;i<ATL.length;i++){ var A=ATL[i]; A.x.drawImage(img,ci*A.w,si*A.h,A.w,A.h); }
    images[v]=img; vReady[v]=1; vList.push(v);
  };
  img.src='data:image/svg+xml;charset=utf-8,'+encodeURIComponent(sneakerSVG2(SIL_NAMES[si],COLORWAYS[ci],v));
}
for(var v=0;v<NV;v++) loadVariant(v);
function blastSprite(v){
  if(blastCache[v]) return blastCache[v];
  var c=document.createElement('canvas'); c.width=640; c.height=Math.round(640*RATIO);
  c.getContext('2d').drawImage(images[v],0,0,c.width,c.height); return (blastCache[v]=c);
}

// ---- state ----------------------------------------------------------------
var nav=navigator,LOW=!!((nav.deviceMemory&&nav.deviceMemory<=4)||(nav.hardwareConcurrency&&nav.hardwareConcurrency<=4)||(nav.connection&&nav.connection.saveData));
var W=0,H=0,DPR=1,CX=0,CY=0,F=0,mobile=false;
var stars=[],shoes=[],blasts=[],target=0,active=0;
var boost=1,rings=[],flung=[],heatFx=null;
var running=false,last=0,clock=0,warp=reduce?1:0,nextBlast=1.2;
var ema=16.7,drawEma=4,slowFrames=0,fastFrames=0,fpsN=0,fpsT=0,fps=0;
function R(a,b){return a+Math.random()*(b-a);}
function pickV(){ return vList.length?vList[(Math.random()*vList.length)|0]:-1; }

function spawnStar(s,anyZ){
  var x,y; do{x=R(-1,1);y=R(-1,1);}while(x*x+y*y<.002);
  s.x=x*1.6;s.y=y*1.6;s.z=anyZ?R(.04,1):R(.85,1);s.v=R(.8,1.2);
  var t=Math.random(); s.c=t<.08?0:t<.14?1:t<.19?2:3; return s;
}
function spawnShoe(s,anyZ){
  var x,y; do{x=R(-1,1);y=R(-1,1);}while(x*x+y*y<.006);
  s.x=x*1.7;s.y=y*1.5;s.z=anyZ?R(.05,1.1):R(.95,1.15);
  s.v=R(.7,1.25); s.sz=R(.6,1.7); s.rot=R(0,6.283); s.vr=R(-3,3);
  s.k=pickV(); return s;
}
function spawnBlast(){
  var ks=Object.keys(blastCache), k=ks.length>8?+ks[(Math.random()*ks.length)|0]:pickV(); if(k<0) return;
  // pick a lane that leaves the text block: mostly sideways on landscape, up/down on portrait
  var side=Math.random()<.5?0:Math.PI, a=(W>H?side:side+Math.PI/2)+R(-.55,.55);
  var r=R(.32,.46);
  blasts.push({x:Math.cos(a)*r*(W>H?1.15:.8),y:Math.sin(a)*r*(W>H?.75:1.1),z:1.05,v:R(.85,1.1),
    k:k,rot:R(-.5,.5)+(Math.cos(a)<0?Math.PI:0)*0,vr:R(-1.6,1.6),flip:Math.cos(a)<0,flashed:false});
}

function resize(){
  DPR=Math.min(window.devicePixelRatio||1,2);
  W=window.innerWidth;H=window.innerHeight;mobile=W<700;
  canvas.width=Math.round(W*DPR);canvas.height=Math.round(H*DPR);
  ctx.setTransform(DPR,0,0,DPR,0,0); ctx.imageSmoothingEnabled=true;
  CX=W/2;CY=H*(mobile?.42:.45);F=Math.max(W,H)*.5;
  var n=Math.round(Math.min(1200,W*H/1e6*CFG.starsPerMpx));
  stars.length=0; for(var i=0;i<n;i++) stars.push(spawnStar({},true));
  target=mobile?(LOW?CFG.shoesMin+100:CFG.shoesMobile):(LOW?1400:CFG.shoesDesktop);
  if(!active||active>target) active=target;
  while(shoes.length<target) shoes.push(spawnShoe({},true));
  shoes.length=target;
  for(i=0;i<shoes.length;i++) spawnShoe(shoes[i],true);
}

// star colour buckets x brightness bins -> batched paths (few strokes / frame)
var SCOL=['182,255,46','0,240,255','255,45,138','255,255,255'], SBIN=4;
var starPaths=[]; for(var ci=0;ci<SCOL.length*SBIN;ci++) starPaths.push([]);
var TR=COLORWAYS.map(function(c){return c.tr;}), trailSegs=TR.map(function(){return [];});

function drawStars(dt,sp,sl,still){
  for(var b=0;b<starPaths.length;b++) starPaths[b].length=0;
  for(var i=0;i<stars.length;i++){
    var s=stars[i];
    s.z-=sp*s.v*dt;
    if(s.z<=.02){spawnStar(s,false);continue;}
    var x1=CX+s.x/s.z*F,y1=CY+s.y/s.z*F;
    if(x1<-60||x1>W+60||y1<-60||y1>H+60){spawnStar(s,false);continue;}
    var z0=Math.min(1.2,s.z+sl*s.v*CFG.speed);
    var near=1-s.z, bin=Math.min(SBIN-1,(near*near*SBIN*1.15)|0);
    starPaths[s.c*SBIN+bin].push(CX+s.x/z0*F,CY+s.y/z0*F,x1,y1);
  }
  ctx.lineCap='round';
  for(b=0;b<starPaths.length;b++){
    var P=starPaths[b]; if(!P.length) continue;
    var bin=b%SBIN, col=SCOL[(b/SBIN)|0];
    ctx.strokeStyle='rgba('+col+','+[.28,.5,.78,1][bin]+')'; ctx.lineWidth=[.6,1.1,1.8,2.8][bin];
    ctx.beginPath(); for(var j=0;j<P.length;j+=4){ctx.moveTo(P[j],P[j+1]);ctx.lineTo(P[j+2],P[j+3]);} ctx.stroke();
  }
}

var bigList=[];
function drawShoes(dt,sp,sl,still){
  var base=CFG.shoeBase*(mobile?.9:1); bigList.length=0;
  for(var t=0;t<trailSegs.length;t++) trailSegs[t].length=0;
  var A0=ATL[0],A1=ATL[1];
  for(var i=0;i<active;i++){
    var p=shoes[i];
    if(p.k<0){p.k=pickV(); if(p.k<0) continue;}
    p.z-=sp*p.v*dt; p.rot+=p.vr*dt;
    if(p.z<=.025){spawnShoe(p,false);continue;}
    var px=CX+p.x/p.z*F, py=CY+p.y/p.z*F, w=base*p.sz/p.z;
    if(px<-w||px>W+w||py<-w||py>H+w){spawnShoe(p,false);continue;}
    var fade=Math.min(1,(1.18-p.z)*3.5); if(fade<=0) continue;
    if(w>30){ bigList.push(p); continue; }
    var h=w*RATIO, si=(p.k/atlasCols)|0, cI=p.k%atlasCols;
    // streak (batched per colour) for anything bigger than a speck
    if(!still&&w>6){ var zb=p.z+sl*p.v*CFG.speed*.9; trailSegs[cI].push(CX+p.x/zb*F,CY+p.y/zb*F,px,py); }
    ctx.globalAlpha=fade*(.55+.45*Math.min(1,w/14));
    var A=w<=18?A0:A1;
    if(w<9){ // tiny specks: no rotation, straight blit from the atlas
      ctx.drawImage(A.c,cI*A.w,si*A.h,A.w,A.h,px-w/2,py-h/2,w,h);
    } else {
      var cs=Math.cos(p.rot)*DPR,sn=Math.sin(p.rot)*DPR;
      ctx.setTransform(cs,sn,-sn,cs,px*DPR,py*DPR);
      ctx.drawImage(A.c,cI*A.w,si*A.h,A.w,A.h,-w/2,-h/2,w,h);
      ctx.setTransform(DPR,0,0,DPR,0,0);
    }
  }
  ctx.globalAlpha=1;
  if(!still){
    ctx.globalCompositeOperation='lighter'; ctx.lineWidth=1.3; ctx.lineCap='round';
    for(t=0;t<trailSegs.length;t++){ var S=trailSegs[t]; if(!S.length) continue;
      ctx.strokeStyle='rgba('+TR[t]+',.26)'; ctx.beginPath();
      for(var j=0;j<S.length;j+=4){ctx.moveTo(S[j],S[j+1]);ctx.lineTo(S[j+2],S[j+3]);} ctx.stroke(); }
    ctx.globalCompositeOperation='source-over';
  }
  // nearer, larger shoes: sorted far->near, gradient streak + motion-blur ghosts
  bigList.sort(function(a,b){return b.z-a.z;});
  for(i=0;i<bigList.length;i++) drawBig(bigList[i],base*bigList[i].sz,ATL[2],sl,still,1);
}
function drawBig(p,sw,A,sl,still,alpha,src){
  var px=CX+p.x/p.z*F,py=CY+p.y/p.z*F,w=sw/p.z,h=w*RATIO;
  var si=(p.k/atlasCols)|0,cI=p.k%atlasCols, tr=TR[cI];
  var sx=src?0:cI*A.w, sy=src?0:si*A.h, sW=src?src.width:A.w, sH=src?src.height:A.h, img=src||A.c;
  if(!still){
    var zb=Math.min(1.4,p.z+sl*1.7*p.v*CFG.speed), bx=CX+p.x/zb*F, by=CY+p.y/zb*F;
    var g=ctx.createLinearGradient(bx,by,px,py);
    g.addColorStop(0,'rgba('+tr+',0)'); g.addColorStop(1,'rgba('+tr+','+(.6*alpha).toFixed(3)+')');
    ctx.globalCompositeOperation='lighter'; ctx.strokeStyle=g; ctx.lineWidth=Math.max(1.5,h*.32); ctx.lineCap='round';
    ctx.beginPath();ctx.moveTo(bx,by);ctx.lineTo(px,py);ctx.stroke();
    for(var gi=2;gi>=1;gi--){ // additive ghosts = motion blur (big shoes only)
      var zg=p.z+(zb-p.z)*gi*.13, gx=CX+p.x/zg*F, gy=CY+p.y/zg*F, gw=sw/zg;
      ctx.globalAlpha=alpha*(gi===1?.34:.17);
      blit(img,sx,sy,sW,sH,gx,gy,gw,p.rot-gi*p.vr*.02,p.flip);
    }
    ctx.globalCompositeOperation='source-over';
  }
  ctx.globalAlpha=alpha; blit(img,sx,sy,sW,sH,px,py,w,p.rot,p.flip); ctx.globalAlpha=1;
  return {x:px,y:py,w:w};
}
function blit(img,sx,sy,sW,sH,x,y,w,rot,flip){
  var h=w*RATIO,cs=Math.cos(rot)*DPR,sn=Math.sin(rot)*DPR,f=flip?-1:1;
  ctx.setTransform(cs*f,sn*f,-sn,cs,x*DPR,y*DPR);
  ctx.drawImage(img,sx,sy,sW,sH,-w/2,-h/2,w,h);
  ctx.setTransform(DPR,0,0,DPR,0,0);
}
function drawBlasts(dt,sp,sl){
  for(var i=blasts.length-1;i>=0;i--){
    var b=blasts[i]; b.z-=sp*b.v*dt*.95; b.rot+=b.vr*dt;
    var px=CX+b.x/b.z*F, py=CY+b.y/b.z*F, w=CFG.blastBase*(mobile?.55:1)/b.z;
    if(b.z<.05||px<-w||px>W+w||py<-w||py>H+w){blasts.splice(i,1);continue;}
    var a=Math.max(0,Math.min(1,(.95-b.z)*3.2));
    // neon flash as it rips past the camera
    var near=Math.max(0,Math.min(1,(w-Math.min(W,H)*.25)/(Math.min(W,H)*.45)));
    if(near>0){
      var tr=TR[b.k%atlasCols], g=ctx.createRadialGradient(px,py,0,px,py,w*1.1);
      g.addColorStop(0,'rgba('+tr+','+(.55*near).toFixed(3)+')'); g.addColorStop(.45,'rgba('+tr+','+(.18*near).toFixed(3)+')'); g.addColorStop(1,'rgba('+tr+',0)');
      ctx.globalCompositeOperation='lighter'; ctx.fillStyle=g; ctx.fillRect(px-w*1.1,py-w*1.1,w*2.2,w*2.2);
      ctx.globalCompositeOperation='source-over';
      if(!b.flashed&&near>.35){ b.flashed=true; document.documentElement.classList.remove('warp-flash'); void document.documentElement.offsetWidth; document.documentElement.classList.add('warp-flash'); }
    }
    drawBig(b,CFG.blastBase*(mobile?.55:1),null,sl,false,a,blastSprite(b.k));
  }
}


// ---- intro FX API (used by intro.js): warp boost, heat halo, impact ring, sneaker burst, embers
function drawFx(dt){
  ctx.globalCompositeOperation='lighter';
  if(heatFx&&heatFx.a>0.01){ var h=heatFx, g=ctx.createRadialGradient(h.x,h.y,0,h.x,h.y,h.r);
    g.addColorStop(0,'rgba(255,240,200,'+(.5*h.a).toFixed(3)+')'); g.addColorStop(.18,'rgba('+h.c+','+(.45*h.a).toFixed(3)+')'); g.addColorStop(.5,'rgba('+h.c+','+(.08*h.a).toFixed(3)+')'); g.addColorStop(.75,'rgba('+h.c+',0)');
    ctx.fillStyle=g; ctx.fillRect(h.x-h.r,h.y-h.r,h.r*2,h.r*2); }
  for(var i=rings.length-1;i>=0;i--){ var r=rings[i]; r.t+=dt; var q=r.t/r.life; if(q>=1){rings.splice(i,1);continue;}
    var e=1-Math.pow(1-q,3), rad=r.r0+(r.r1-r.r0)*e, a=(1-q);
    ctx.lineWidth=Math.max(1,r.w*(1-q*.7));
    ctx.strokeStyle='rgba('+r.c+','+(a*.9).toFixed(3)+')'; ctx.beginPath(); ctx.ellipse(r.x,r.y,rad,rad*r.sq,0,0,6.2832); ctx.stroke();
    ctx.lineWidth=Math.max(1,r.w*3*(1-q)); ctx.strokeStyle='rgba('+r.c+','+(a*.22).toFixed(3)+')'; ctx.stroke();
    if(q<.12){ var fa=(1-q/.12)*.6, fr=r.r1*.38, fg=ctx.createRadialGradient(r.x,r.y,0,r.x,r.y,fr); fg.addColorStop(0,'rgba(255,255,240,'+fa.toFixed(3)+')'); fg.addColorStop(.3,'rgba('+r.c+','+(fa*.35).toFixed(3)+')'); fg.addColorStop(.7,'rgba('+r.c+',0)'); ctx.fillStyle=fg; ctx.fillRect(r.x-fr,r.y-fr,fr*2,fr*2); }
  }
  ctx.globalCompositeOperation='source-over';
  var A=ATL[1],B=ATL[2];
  for(i=flung.length-1;i>=0;i--){ var f=flung[i]; f.t+=dt; if(f.t>=f.life){flung.splice(i,1);continue;}
    var drag=Math.pow(f.ember?.2:.35,dt); f.vx*=drag; f.vy*=drag; f.vy+=(f.ember?-30:60)*dt; f.x+=f.vx*dt; f.y+=f.vy*dt; f.rot+=f.vr*dt;
    var fade=1-f.t/f.life;
    if(f.ember){ ctx.globalCompositeOperation='lighter'; ctx.fillStyle='rgba('+f.c+','+(fade*.9).toFixed(3)+')'; var sz=f.w*(.4+.6*fade); ctx.fillRect(f.x-sz/2,f.y-sz/2,sz,sz); ctx.globalCompositeOperation='source-over'; continue; }
    var S=f.w>48?B:A, si=(f.k/atlasCols)|0, ci=f.k%atlasCols, w=f.w*(1+f.t*.8);
    // short glowing trail
    ctx.globalCompositeOperation='lighter'; ctx.strokeStyle='rgba('+TR[ci]+','+(.5*fade).toFixed(3)+')'; ctx.lineWidth=Math.max(1,w*.18);
    ctx.beginPath(); ctx.moveTo(f.x-f.vx*.06,f.y-f.vy*.06); ctx.lineTo(f.x,f.y); ctx.stroke(); ctx.globalCompositeOperation='source-over';
    ctx.globalAlpha=Math.min(1,fade*1.6); blit(S.c,ci*S.w,si*S.h,S.w,S.h,f.x,f.y,w,f.rot,f.vx<0); ctx.globalAlpha=1;
  }
}
window.ShoeWarp={
  setBoost:function(m){ boost=Math.max(.2,m); },
  heat:function(x,y,r,a,c){ heatFx=a>0?{x:x,y:y,r:r,a:a,c:c||'255,106,19'}:null; },
  impact:function(x,y,o){ o=o||{}; var big=Math.max(W,H);
    rings.push({x:x,y:y,r0:20,r1:big*.75,w:mobile?5:8,life:.9,t:0,sq:.42,c:o.c1||'0,240,255'});
    rings.push({x:x,y:y,r0:10,r1:big*.5,w:mobile?3:5,life:.7,t:0,sq:.42,c:o.c2||'255,45,138'});
    var n=mobile?36:80, spread=o.spread||Math.min(W*.35,420);
    for(var i=0;i<n&&vList.length;i++){ var a=Math.random()*6.2832, v=R(500,1500)*(mobile?.6:1);
      flung.push({x:x+Math.cos(a)*R(0,spread),y:y+Math.sin(a)*R(0,spread*.3),vx:Math.cos(a)*v,vy:Math.sin(a)*v*.7-R(0,200),rot:R(0,6.28),vr:R(-9,9),
        w:R(16,mobile?46:70),k:pickV(),t:0,life:R(.9,1.5)}); }
  },
  embers:function(x,y,n,spread,c){ for(var i=0;i<n;i++){ var a=Math.random()*6.2832,v=R(40,260);
    flung.push({ember:1,x:x+R(-spread,spread),y:y+R(-spread*.3,spread*.3),vx:Math.cos(a)*v,vy:Math.sin(a)*v,w:R(1.5,4.5),t:0,life:R(.35,.9),
      c:c||(Math.random()<.5?'255,170,60':'255,70,20'),rot:0,vr:0}); } },
  ready:function(){ return vList.length===NV; },
  vanishingPoint:function(){ return {x:CX,y:CY}; }
};

function draw(dt,still){
  var sp=still?0:CFG.speed*warp*boost, sl=CFG.streak*(.25+.75*warp)*(1+(boost-1)*.6);
  ctx.globalCompositeOperation='source-over';ctx.globalAlpha=1;
  ctx.fillStyle='#000';ctx.fillRect(0,0,W,H);
  drawStars(dt,sp,sl,still);
  drawShoes(dt,sp,sl,still);
  if(!still){ drawBlasts(dt,sp,sl); drawFx(dt); }
}

function adapt(ms){
  ema=ema*.9+ms*.1;
  if(ema>CFG.slowMs){ if(++slowFrames>30){ active=Math.max(CFG.shoesMin,Math.round(active*.85)); slowFrames=0; ema=16.7; } }
  else slowFrames=0;
  if(drawEma<CFG.recoverDrawMs&&ema<18&&active<target){ if(++fastFrames>90){ active=Math.min(target,Math.round(active*1.1)); fastFrames=0; } }
  else fastFrames=0;
}
function frame(now){
  if(!running) return;
  var ms=last?now-last:16.7; last=now; var dt=Math.min(.05,ms/1000); clock+=dt;
  if(warp<1){ var r=Math.min(1,clock/CFG.ramp); warp=Math.max(.02,r*r*(3-2*r)); }
  if(clock>1) adapt(ms);
  if(clock>=nextBlast&&vList.length){ spawnBlast(); nextBlast=clock+R(CFG.blastEvery[0],CFG.blastEvery[1]); }
  var t0=performance.now(); draw(dt,false); drawEma=drawEma*.95+(performance.now()-t0)*.05;
  fpsN++; fpsT+=ms; if(fpsT>=1000){ fps=Math.round(fpsN*1000/fpsT); fpsN=0; fpsT=0; }
  window.__warp={particles:active,target:target,stars:stars.length,variants:vList.length,silhouettes:SIL_NAMES.length,colorways:COLORWAYS.length,fps:fps,frameMsAvg:+ema.toFixed(1),drawMsAvg:+drawEma.toFixed(2),blasts:blasts.length};
  requestAnimationFrame(frame);
}
function still(){
  // reduced motion: one calm composed frame. Stars as dots/short dashes,
  // clean single shoes (no streaks, ghosts or flashes), bigger ones kept clear of the text.
  ctx.setTransform(DPR,0,0,DPR,0,0); ctx.globalAlpha=1; ctx.globalCompositeOperation='source-over';
  ctx.fillStyle='#000'; ctx.fillRect(0,0,W,H);
  for(var i=0;i<stars.length;i++){ var st=stars[i], x=CX+st.x/st.z*F, y=CY+st.y/st.z*F; if(x<0||x>W||y<0||y>H) continue;
    var a=.25+.75*(1-st.z); ctx.fillStyle='rgba('+SCOL[st.c]+','+a.toFixed(2)+')'; var r=.5+1.3*(1-st.z); ctx.fillRect(x-r/2,y-r/2,r,r); }
  if(!vList.length) return;
  var n=mobile?140:320, A=ATL[1], B=ATL[2], seed=7;
  function rnd(){ seed=(seed*16807)%2147483647; return seed/2147483647; }
  var hx=Math.min(W*.42,560), hy=H*.34; // keep-out box around the hero copy
  for(i=0;i<n;i++){
    var big=i<(mobile?6:12), w=big?(mobile?54:80)+rnd()*(mobile?36:70):5+Math.pow(rnd(),2.2)*(mobile?22:30);
    var x=rnd()*W, y=rnd()*H;
    var inBox=Math.abs(x-CX)<hx+w*.6&&Math.abs(y-CY)<hy+w*.4;
    if(big&&(inBox||y<90+w*.3)){ i--; continue; }
    var k=vList[(rnd()*vList.length)|0], si=(k/atlasCols)|0, ci=k%atlasCols, S=w>40?B:A;
    var rot=(rnd()-.5)*1.2, cs=Math.cos(rot)*DPR, sn=Math.sin(rot)*DPR;
    ctx.globalAlpha=big?1:(.55+.45*Math.min(1,w/20))*(inBox?.5:1);
    ctx.setTransform(cs,sn,-sn,cs,x*DPR,y*DPR);
    ctx.drawImage(S.c,ci*S.w,si*S.h,S.w,S.h,-w/2,-w*RATIO/2,w,w*RATIO);
  }
  ctx.setTransform(DPR,0,0,DPR,0,0); ctx.globalAlpha=1;
  window.__warp={still:true,shoes:n,variants:vList.length};
}
var warmed=0;
function prewarm(){
  if(vList.length<NV||warmed>=40) return;
  var k=vList[(Math.random()*vList.length)|0]; if(!blastCache[k]){ blastSprite(k); warmed++; }
  (window.requestIdleCallback||function(f){setTimeout(f,60);})(prewarm);
}
setTimeout(prewarm,400);
function play(){ if(running||reduce) return; running=true; last=0; requestAnimationFrame(frame); }
function pause(){ running=false; }
function start(){ resize(); if(reduce) still(); else play(); }
// start right away (stars first); shoes join as their variants finish loading
/* start after first paint so the canvas never blocks initial render */
function boot(){ requestAnimationFrame(function(){ setTimeout(start,0); }); }
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
if(reduce){ var chk=setInterval(function(){ if(vList.length===NV){ clearInterval(chk); still(); } },50); }
document.addEventListener('visibilitychange',function(){ document.hidden?pause():play(); }); // runs behind the whole page; pauses only when the tab is hidden
var rt;window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(function(){ resize(); if(reduce) still(); },120); });
// intensity: full in the hero, a little calmer behind content. Inner pages pass data-max / data-floor on the canvas.
var capOp=parseFloat(canvas.getAttribute('data-max')||'1'), floorOp=parseFloat(canvas.getAttribute('data-floor')||'.72'), heroFade=-1;
function fade(){ var f=Math.min(capOp,Math.max(floorOp,1-(window.scrollY||0)/(H*1.2))); if(Math.abs(f-heroFade)>.02){heroFade=f;canvas.style.opacity=f.toFixed(2);} }
window.addEventListener('scroll',fade,{passive:true}); fade();
})();